import * as React from 'react';

interface IGeoLinkProps {
  className?: string;
}
export function GeoLinkIcon(props: IGeoLinkProps) {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path d="M11.9805 3.50391L9.00781 13.4844L7.12305 8.36133L2 6.47656L11.9805 3.50391Z" />
    </svg>
  );
}
